// @flow

// Action Type
import * as actionTypesNavigation from 'store/reducers/navigation/actionTypes';

// Actions
import { generateTokenId } from 'store/reducers/tokenId/actions';

// Selectors
import { isLoggedIn } from 'store/reducers/user/selectors';

// Constants
import { HOME_ROUTE } from 'constants/routes';

// types
import type { Store, Action } from 'types/redux';

export const navigationMiddleware = (store: Store) => (
  next: (action: Action) => any
) => (action: any) => {
  switch (action.type) {
    case actionTypesNavigation.SET_CURRENT_PATH: {
      if (isLoggedIn(store.getState()) && action.payload === HOME_ROUTE) {
        store.dispatch(generateTokenId());
      }
      break;
    }
    default:
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/store/middlewares/navigation-middleware.js